import { ObjectValues } from 'types';
import { DealRoom } from './DealRoom';

export const DEAL_ROOM_SEARCH = {
  DRAFTS: 'drafts',
  SELLING: 'selling',
  BUYING: 'buying',
  MARKETPLACE: 'marketplace',
} as const;

export type DealRoomSearch = ObjectValues<typeof DEAL_ROOM_SEARCH>;

export type DealRoomSearchResults = {
  [DEAL_ROOM_SEARCH.DRAFTS]: DealRoom[];
  [DEAL_ROOM_SEARCH.SELLING]: DealRoom[];
  [DEAL_ROOM_SEARCH.BUYING]: DealRoom[];
  [DEAL_ROOM_SEARCH.MARKETPLACE]: DealRoom[];
};
